/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetBranchesDocument = gql`
    query GetBranches($itemsPerPage: Int, $page: Int, $branchTypeId: Int, $name: String, $companyId: Int!, $employeeId: Int, $onlyActive: Boolean, $isDeleted: Boolean) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      name
      image
      branchesPaginated(
        itemsPerPage: $itemsPerPage
        page: $page
        branchTypeId: $branchTypeId
        search: $name
        isDeleted: $isDeleted
      ) {
        pageCount
        currentPage
        itemsPerPage
        totalCount
        branches {
          deleted
          rating
          id
          email
          image
          name
          description
          country {
            id
            name
          }
          city {
            id
            name
          }
          phones {
            phone
          }
          type {
            id
            name
          }
          website
          workSchedule
          description
          branchImages
          address
          category {
            id
            name
          }
          socialLink {
            instagram
            facebook
            youtube
            whatsapp
          }
          employeesPaginated(onlyActive: $onlyActive, id: $employeeId) {
            employees {
              userBranchRelations {
                branch {
                  id
                }
                role {
                  id
                  name
                }
              }
            }
          }
          totalEmployees: employeesPaginated(onlyActive: $onlyActive) {
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchesQuery__
 *
 * To run a query within a React component, call `useGetBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      branchTypeId: // value for 'branchTypeId'
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      onlyActive: // value for 'onlyActive'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useGetBranchesQuery(baseOptions: Apollo.QueryHookOptions<GetBranchesQuery, GetBranchesQueryVariables> & ({ variables: GetBranchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchesQuery, GetBranchesQueryVariables>(GetBranchesDocument, options);
      }
export function useGetBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchesQuery, GetBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchesQuery, GetBranchesQueryVariables>(GetBranchesDocument, options);
        }
export function useGetBranchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchesQuery, GetBranchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchesQuery, GetBranchesQueryVariables>(GetBranchesDocument, options);
        }
export type GetBranchesQueryHookResult = ReturnType<typeof useGetBranchesQuery>;
export type GetBranchesLazyQueryHookResult = ReturnType<typeof useGetBranchesLazyQuery>;
export type GetBranchesSuspenseQueryHookResult = ReturnType<typeof useGetBranchesSuspenseQuery>;
export type GetBranchesQueryResult = Apollo.QueryResult<GetBranchesQuery, GetBranchesQueryVariables>;
export const GetBranchListDocument = gql`
    query GetBranchList($itemsPerPage: Int, $page: Int, $branchTypeId: Int, $name: String, $companyId: Int!, $employeeId: Int, $onlyActive: Boolean, $isDeleted: Boolean) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(
        itemsPerPage: $itemsPerPage
        page: $page
        branchTypeId: $branchTypeId
        search: $name
        isDeleted: $isDeleted
      ) {
        pageCount
        currentPage
        itemsPerPage
        totalCount
        branches {
          deleted
          rating
          id
          image
          name
          description
          branchImages
          employeesPaginated(onlyActive: $onlyActive, id: $employeeId) {
            employees {
              userBranchRelations {
                branch {
                  id
                }
              }
            }
          }
          totalEmployees: employeesPaginated(onlyActive: $onlyActive) {
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchListQuery__
 *
 * To run a query within a React component, call `useGetBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchListQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      branchTypeId: // value for 'branchTypeId'
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      onlyActive: // value for 'onlyActive'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useGetBranchListQuery(baseOptions: Apollo.QueryHookOptions<GetBranchListQuery, GetBranchListQueryVariables> & ({ variables: GetBranchListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchListQuery, GetBranchListQueryVariables>(GetBranchListDocument, options);
      }
export function useGetBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchListQuery, GetBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchListQuery, GetBranchListQueryVariables>(GetBranchListDocument, options);
        }
export function useGetBranchListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchListQuery, GetBranchListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchListQuery, GetBranchListQueryVariables>(GetBranchListDocument, options);
        }
export type GetBranchListQueryHookResult = ReturnType<typeof useGetBranchListQuery>;
export type GetBranchListLazyQueryHookResult = ReturnType<typeof useGetBranchListLazyQuery>;
export type GetBranchListSuspenseQueryHookResult = ReturnType<typeof useGetBranchListSuspenseQuery>;
export type GetBranchListQueryResult = Apollo.QueryResult<GetBranchListQuery, GetBranchListQueryVariables>;
export const GetBranchDocument = gql`
    query GetBranch($id: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      timeZone {
        name
      }
      branchesPaginated(id: $id) {
        isCanCreateNewBranch
        branches {
          deleted
          id
          email
          image
          name
          description
          currencyCode
          onlineRegistration
          bookingQrLink
          removedOfTariff
          isAnyActiveServiceEmployeeRelations
          isAnyActiveServices
          isAnyWorkScheduleForWorkingEmployees
          generalWorkSchedules {
            id
            type {
              id
              name
              slug
            }
            day {
              id
              name
              shortName
              number
            }
            period
          }
          kitchenWorkSchedules {
            id
            type {
              id
              name
              slug
            }
            day {
              id
              name
              shortName
              number
            }
            period
          }
          country {
            id
            name
            localeCode
            continentName
            isoCode
            isInEuropeanUnion
          }
          city {
            id
            name
          }
          phones {
            id
            phone
            branch {
              id
              country {
                id
                isInEuropeanUnion
                continentName
                isoCode
                localeCode
                name
              }
              name
              address
              timeZone
              currencyCode
              deleted
              onlineRegistration
              bookingQrLink
              removedOfTariff
              isAnyActiveServiceEmployeeRelations
              isAnyActiveServices
              isAnyWorkScheduleForWorkingEmployees
            }
          }
          type {
            id
            name
            slug
          }
          timeZone
          website
          workSchedule
          description
          branchImages
          address
          category {
            id
            name
            type
          }
          socialLink {
            id
            instagram
            facebook
            youtube
            whatsapp
            branch {
              id
              country {
                id
                isInEuropeanUnion
                continentName
                isoCode
                localeCode
                name
              }
              name
              address
              timeZone
              currencyCode
              deleted
              onlineRegistration
              bookingQrLink
              removedOfTariff
              isAnyActiveServiceEmployeeRelations
              isAnyActiveServices
              isAnyWorkScheduleForWorkingEmployees
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchQuery__
 *
 * To run a query within a React component, call `useGetBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetBranchQuery(baseOptions: Apollo.QueryHookOptions<GetBranchQuery, GetBranchQueryVariables> & ({ variables: GetBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchQuery, GetBranchQueryVariables>(GetBranchDocument, options);
      }
export function useGetBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchQuery, GetBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchQuery, GetBranchQueryVariables>(GetBranchDocument, options);
        }
export function useGetBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchQuery, GetBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchQuery, GetBranchQueryVariables>(GetBranchDocument, options);
        }
export type GetBranchQueryHookResult = ReturnType<typeof useGetBranchQuery>;
export type GetBranchLazyQueryHookResult = ReturnType<typeof useGetBranchLazyQuery>;
export type GetBranchSuspenseQueryHookResult = ReturnType<typeof useGetBranchSuspenseQuery>;
export type GetBranchQueryResult = Apollo.QueryResult<GetBranchQuery, GetBranchQueryVariables>;
export const GetBranchTypesDocument = gql`
    query GetBranchTypes($branchId: Int!, $onlyChild: Boolean, $onlyMeMenu: Boolean) {
  branchTypes(branchId: $branchId, onlyChild: $onlyChild, onlyMeMenu: $onlyMeMenu) {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetBranchTypesQuery__
 *
 * To run a query within a React component, call `useGetBranchTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchTypesQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      onlyChild: // value for 'onlyChild'
 *      onlyMeMenu: // value for 'onlyMeMenu'
 *   },
 * });
 */
export function useGetBranchTypesQuery(baseOptions: Apollo.QueryHookOptions<GetBranchTypesQuery, GetBranchTypesQueryVariables> & ({ variables: GetBranchTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchTypesQuery, GetBranchTypesQueryVariables>(GetBranchTypesDocument, options);
      }
export function useGetBranchTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchTypesQuery, GetBranchTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchTypesQuery, GetBranchTypesQueryVariables>(GetBranchTypesDocument, options);
        }
export function useGetBranchTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchTypesQuery, GetBranchTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchTypesQuery, GetBranchTypesQueryVariables>(GetBranchTypesDocument, options);
        }
export type GetBranchTypesQueryHookResult = ReturnType<typeof useGetBranchTypesQuery>;
export type GetBranchTypesLazyQueryHookResult = ReturnType<typeof useGetBranchTypesLazyQuery>;
export type GetBranchTypesSuspenseQueryHookResult = ReturnType<typeof useGetBranchTypesSuspenseQuery>;
export type GetBranchTypesQueryResult = Apollo.QueryResult<GetBranchTypesQuery, GetBranchTypesQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  relations {
    countries {
      id
      name
      europeanUnion
    }
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const CreateNewBranchDocument = gql`
    mutation CreateNewBranch($companyId: Int!, $input: BranchInput!) {
  createBranch(companyId: $companyId, input: $input) {
    id
    category {
      id
      name
    }
    name
    country {
      id
      name
    }
  }
}
    `;
export type CreateNewBranchMutationFn = Apollo.MutationFunction<CreateNewBranchMutation, CreateNewBranchMutationVariables>;

/**
 * __useCreateNewBranchMutation__
 *
 * To run a mutation, you first call `useCreateNewBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewBranchMutation, { data, loading, error }] = useCreateNewBranchMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewBranchMutation, CreateNewBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewBranchMutation, CreateNewBranchMutationVariables>(CreateNewBranchDocument, options);
      }
export type CreateNewBranchMutationHookResult = ReturnType<typeof useCreateNewBranchMutation>;
export type CreateNewBranchMutationResult = Apollo.MutationResult<CreateNewBranchMutation>;
export type CreateNewBranchMutationOptions = Apollo.BaseMutationOptions<CreateNewBranchMutation, CreateNewBranchMutationVariables>;
export const UpdateBranchDocument = gql`
    mutation UpdateBranch($id: Int!, $input: BranchInput!) {
  updateBranch(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateBranchMutationFn = Apollo.MutationFunction<UpdateBranchMutation, UpdateBranchMutationVariables>;

/**
 * __useUpdateBranchMutation__
 *
 * To run a mutation, you first call `useUpdateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchMutation, { data, loading, error }] = useUpdateBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchMutation, UpdateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchMutation, UpdateBranchMutationVariables>(UpdateBranchDocument, options);
      }
export type UpdateBranchMutationHookResult = ReturnType<typeof useUpdateBranchMutation>;
export type UpdateBranchMutationResult = Apollo.MutationResult<UpdateBranchMutation>;
export type UpdateBranchMutationOptions = Apollo.BaseMutationOptions<UpdateBranchMutation, UpdateBranchMutationVariables>;
export const RestoreBranchDocument = gql`
    mutation RestoreBranch($id: Int!, $input: BranchInput!) {
  restoreBranch(id: $id, input: $input) {
    id
  }
}
    `;
export type RestoreBranchMutationFn = Apollo.MutationFunction<RestoreBranchMutation, RestoreBranchMutationVariables>;

/**
 * __useRestoreBranchMutation__
 *
 * To run a mutation, you first call `useRestoreBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreBranchMutation, { data, loading, error }] = useRestoreBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreBranchMutation(baseOptions?: Apollo.MutationHookOptions<RestoreBranchMutation, RestoreBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreBranchMutation, RestoreBranchMutationVariables>(RestoreBranchDocument, options);
      }
export type RestoreBranchMutationHookResult = ReturnType<typeof useRestoreBranchMutation>;
export type RestoreBranchMutationResult = Apollo.MutationResult<RestoreBranchMutation>;
export type RestoreBranchMutationOptions = Apollo.BaseMutationOptions<RestoreBranchMutation, RestoreBranchMutationVariables>;
export const DeleteBranchDocument = gql`
    mutation DeleteBranch($id: Int!) {
  deleteBranch(id: $id)
}
    `;
export type DeleteBranchMutationFn = Apollo.MutationFunction<DeleteBranchMutation, DeleteBranchMutationVariables>;

/**
 * __useDeleteBranchMutation__
 *
 * To run a mutation, you first call `useDeleteBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBranchMutation, { data, loading, error }] = useDeleteBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBranchMutation, DeleteBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBranchMutation, DeleteBranchMutationVariables>(DeleteBranchDocument, options);
      }
export type DeleteBranchMutationHookResult = ReturnType<typeof useDeleteBranchMutation>;
export type DeleteBranchMutationResult = Apollo.MutationResult<DeleteBranchMutation>;
export type DeleteBranchMutationOptions = Apollo.BaseMutationOptions<DeleteBranchMutation, DeleteBranchMutationVariables>;
export const GetCompanyCreateBranchDocument = gql`
    query GetCompanyCreateBranch($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      country {
        id
        name
      }
      city {
        id
        name
      }
      phone
      address
      website
    }
  }
}
    `;

/**
 * __useGetCompanyCreateBranchQuery__
 *
 * To run a query within a React component, call `useGetCompanyCreateBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCreateBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCreateBranchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyCreateBranchQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables> & ({ variables: GetCompanyCreateBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>(GetCompanyCreateBranchDocument, options);
      }
export function useGetCompanyCreateBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>(GetCompanyCreateBranchDocument, options);
        }
export function useGetCompanyCreateBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>(GetCompanyCreateBranchDocument, options);
        }
export type GetCompanyCreateBranchQueryHookResult = ReturnType<typeof useGetCompanyCreateBranchQuery>;
export type GetCompanyCreateBranchLazyQueryHookResult = ReturnType<typeof useGetCompanyCreateBranchLazyQuery>;
export type GetCompanyCreateBranchSuspenseQueryHookResult = ReturnType<typeof useGetCompanyCreateBranchSuspenseQuery>;
export type GetCompanyCreateBranchQueryResult = Apollo.QueryResult<GetCompanyCreateBranchQuery, GetCompanyCreateBranchQueryVariables>;
export const GetCountryGeoDocument = gql`
    query GetCountryGeo {
  countryGeo {
    country {
      id
      isoCode
      phoneCode {
        code
      }
      currencies {
        id
      }
      timezone {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountryGeoQuery__
 *
 * To run a query within a React component, call `useGetCountryGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryGeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryGeoQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryGeoQuery, GetCountryGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryGeoQuery, GetCountryGeoQueryVariables>(GetCountryGeoDocument, options);
      }
export function useGetCountryGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryGeoQuery, GetCountryGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryGeoQuery, GetCountryGeoQueryVariables>(GetCountryGeoDocument, options);
        }
export function useGetCountryGeoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryGeoQuery, GetCountryGeoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryGeoQuery, GetCountryGeoQueryVariables>(GetCountryGeoDocument, options);
        }
export type GetCountryGeoQueryHookResult = ReturnType<typeof useGetCountryGeoQuery>;
export type GetCountryGeoLazyQueryHookResult = ReturnType<typeof useGetCountryGeoLazyQuery>;
export type GetCountryGeoSuspenseQueryHookResult = ReturnType<typeof useGetCountryGeoSuspenseQuery>;
export type GetCountryGeoQueryResult = Apollo.QueryResult<GetCountryGeoQuery, GetCountryGeoQueryVariables>;
export const GetCurrentBranchIdDocument = gql`
    query GetCurrentBranchId {
  user {
    id
    currentBranch {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentBranchIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentBranchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBranchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBranchIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentBranchIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>(GetCurrentBranchIdDocument, options);
      }
export function useGetCurrentBranchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>(GetCurrentBranchIdDocument, options);
        }
export function useGetCurrentBranchIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>(GetCurrentBranchIdDocument, options);
        }
export type GetCurrentBranchIdQueryHookResult = ReturnType<typeof useGetCurrentBranchIdQuery>;
export type GetCurrentBranchIdLazyQueryHookResult = ReturnType<typeof useGetCurrentBranchIdLazyQuery>;
export type GetCurrentBranchIdSuspenseQueryHookResult = ReturnType<typeof useGetCurrentBranchIdSuspenseQuery>;
export type GetCurrentBranchIdQueryResult = Apollo.QueryResult<GetCurrentBranchIdQuery, GetCurrentBranchIdQueryVariables>;
export const UpdateCurrentBranchDocument = gql`
    mutation updateCurrentBranch($companyId: Int, $branchId: Int!) {
  updateCurrentBranch(companyId: $companyId, branchId: $branchId)
}
    `;
export type UpdateCurrentBranchMutationFn = Apollo.MutationFunction<UpdateCurrentBranchMutation, UpdateCurrentBranchMutationVariables>;

/**
 * __useUpdateCurrentBranchMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentBranchMutation, { data, loading, error }] = useUpdateCurrentBranchMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateCurrentBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentBranchMutation, UpdateCurrentBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentBranchMutation, UpdateCurrentBranchMutationVariables>(UpdateCurrentBranchDocument, options);
      }
export type UpdateCurrentBranchMutationHookResult = ReturnType<typeof useUpdateCurrentBranchMutation>;
export type UpdateCurrentBranchMutationResult = Apollo.MutationResult<UpdateCurrentBranchMutation>;
export type UpdateCurrentBranchMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentBranchMutation, UpdateCurrentBranchMutationVariables>;
export const GetBranchEmployeesDocument = gql`
    query GetBranchEmployees($companyId: Int!, $branchId: Int, $itemsPerPage: Int, $page: Int, $onlyActive: Boolean) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        id
        name
        employeesPaginated(
          itemsPerPage: $itemsPerPage
          page: $page
          onlyActive: $onlyActive
        ) {
          totalCount
          currentPage
          itemsPerPage
          pageCount
          employees {
            id
            image
            name
            surname
            specialization
            role {
              id
              name
              isOwner
            }
            position {
              name
            }
            userBranchRelations {
              id
              branch {
                name
                id
              }
              role {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchEmployeesQuery__
 *
 * To run a query within a React component, call `useGetBranchEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchEmployeesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      onlyActive: // value for 'onlyActive'
 *   },
 * });
 */
export function useGetBranchEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables> & ({ variables: GetBranchEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>(GetBranchEmployeesDocument, options);
      }
export function useGetBranchEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>(GetBranchEmployeesDocument, options);
        }
export function useGetBranchEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>(GetBranchEmployeesDocument, options);
        }
export type GetBranchEmployeesQueryHookResult = ReturnType<typeof useGetBranchEmployeesQuery>;
export type GetBranchEmployeesLazyQueryHookResult = ReturnType<typeof useGetBranchEmployeesLazyQuery>;
export type GetBranchEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetBranchEmployeesSuspenseQuery>;
export type GetBranchEmployeesQueryResult = Apollo.QueryResult<GetBranchEmployeesQuery, GetBranchEmployeesQueryVariables>;
export const GetBranchesForCompanyDocument = gql`
    query GetBranchesForCompany($companyId: Int!, $employeeId: Int) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      name
      branchesPaginated(isDeleted: false) {
        branches {
          deleted
          id
          employeesPaginated(id: $employeeId) {
            employees {
              userBranchRelations {
                branch {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetBranchesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetBranchesForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables> & ({ variables: GetBranchesForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>(GetBranchesForCompanyDocument, options);
      }
export function useGetBranchesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>(GetBranchesForCompanyDocument, options);
        }
export function useGetBranchesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>(GetBranchesForCompanyDocument, options);
        }
export type GetBranchesForCompanyQueryHookResult = ReturnType<typeof useGetBranchesForCompanyQuery>;
export type GetBranchesForCompanyLazyQueryHookResult = ReturnType<typeof useGetBranchesForCompanyLazyQuery>;
export type GetBranchesForCompanySuspenseQueryHookResult = ReturnType<typeof useGetBranchesForCompanySuspenseQuery>;
export type GetBranchesForCompanyQueryResult = Apollo.QueryResult<GetBranchesForCompanyQuery, GetBranchesForCompanyQueryVariables>;
export const GetIsoCodeForBranchDocument = gql`
    query GetIsoCodeForBranch($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      country {
        isoCode
      }
    }
  }
}
    `;

/**
 * __useGetIsoCodeForBranchQuery__
 *
 * To run a query within a React component, call `useGetIsoCodeForBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsoCodeForBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsoCodeForBranchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetIsoCodeForBranchQuery(baseOptions: Apollo.QueryHookOptions<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables> & ({ variables: GetIsoCodeForBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>(GetIsoCodeForBranchDocument, options);
      }
export function useGetIsoCodeForBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>(GetIsoCodeForBranchDocument, options);
        }
export function useGetIsoCodeForBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>(GetIsoCodeForBranchDocument, options);
        }
export type GetIsoCodeForBranchQueryHookResult = ReturnType<typeof useGetIsoCodeForBranchQuery>;
export type GetIsoCodeForBranchLazyQueryHookResult = ReturnType<typeof useGetIsoCodeForBranchLazyQuery>;
export type GetIsoCodeForBranchSuspenseQueryHookResult = ReturnType<typeof useGetIsoCodeForBranchSuspenseQuery>;
export type GetIsoCodeForBranchQueryResult = Apollo.QueryResult<GetIsoCodeForBranchQuery, GetIsoCodeForBranchQueryVariables>;
export const GetBranchNameDocument = gql`
    query GetBranchName($companyId: Int!, $branchId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $branchId) {
        branches {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetBranchNameQuery__
 *
 * To run a query within a React component, call `useGetBranchNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchNameQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetBranchNameQuery(baseOptions: Apollo.QueryHookOptions<GetBranchNameQuery, GetBranchNameQueryVariables> & ({ variables: GetBranchNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchNameQuery, GetBranchNameQueryVariables>(GetBranchNameDocument, options);
      }
export function useGetBranchNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchNameQuery, GetBranchNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchNameQuery, GetBranchNameQueryVariables>(GetBranchNameDocument, options);
        }
export function useGetBranchNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchNameQuery, GetBranchNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchNameQuery, GetBranchNameQueryVariables>(GetBranchNameDocument, options);
        }
export type GetBranchNameQueryHookResult = ReturnType<typeof useGetBranchNameQuery>;
export type GetBranchNameLazyQueryHookResult = ReturnType<typeof useGetBranchNameLazyQuery>;
export type GetBranchNameSuspenseQueryHookResult = ReturnType<typeof useGetBranchNameSuspenseQuery>;
export type GetBranchNameQueryResult = Apollo.QueryResult<GetBranchNameQuery, GetBranchNameQueryVariables>;
export type GetBranchesQueryVariables = Types.Exact<{
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchTypeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyId: Types.Scalars['Int']['input'];
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  onlyActive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetBranchesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', name: string, image?: string | null, branchesPaginated?: { __typename?: 'BranchPaginated', pageCount?: string | null, currentPage?: number | null, itemsPerPage?: number | null, totalCount?: number | null, branches?: Array<{ __typename?: 'BranchProxy', deleted: boolean, rating?: number | null, id: number, email?: string | null, image?: string | null, name: string, description?: string | null, website?: string | null, workSchedule?: string | null, branchImages?: Array<string> | null, address: string, country: { __typename?: 'Country', id: string, name: string }, city?: { __typename?: 'CityProxy', id: number, name: string } | null, phones?: Array<{ __typename?: 'BranchPhoneProxy', phone: string }> | null, type?: { __typename?: 'BranchTypeProxy', id: number, name: string } | null, category?: { __typename?: 'CompanyTypeProxy', id: number, name: string } | null, socialLink?: { __typename?: 'BranchSocialLinkProxy', instagram?: string | null, facebook?: string | null, youtube?: string | null, whatsapp?: string | null } | null, employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', branch: { __typename?: 'BranchProxy', id: number }, role: { __typename?: 'RoleProxy', id: number, name: string } }> | null }> | null } | null, totalEmployees?: { __typename?: 'EmployeePaginated', totalCount?: number | null } | null }> | null } | null } | null } | null };

export type GetBranchListQueryVariables = Types.Exact<{
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchTypeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  companyId: Types.Scalars['Int']['input'];
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  onlyActive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetBranchListQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', pageCount?: string | null, currentPage?: number | null, itemsPerPage?: number | null, totalCount?: number | null, branches?: Array<{ __typename?: 'BranchProxy', deleted: boolean, rating?: number | null, id: number, image?: string | null, name: string, description?: string | null, branchImages?: Array<string> | null, employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', branch: { __typename?: 'BranchProxy', id: number } }> | null }> | null } | null, totalEmployees?: { __typename?: 'EmployeePaginated', totalCount?: number | null } | null }> | null } | null } | null } | null };

export type GetBranchQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetBranchQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, timeZone?: { __typename?: 'TimeZoneProxy', name: string } | null, branchesPaginated?: { __typename?: 'BranchPaginated', isCanCreateNewBranch: boolean, branches?: Array<{ __typename?: 'BranchProxy', deleted: boolean, id: number, email?: string | null, image?: string | null, name: string, description?: string | null, currencyCode: string, onlineRegistration: boolean, bookingQrLink: string, removedOfTariff: boolean, isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, timeZone: string, website?: string | null, workSchedule?: string | null, branchImages?: Array<string> | null, address: string, generalWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, type: { __typename?: 'BranchWorkPeriodTypeProxy', id: number, name: string, slug: string }, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null, kitchenWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, type: { __typename?: 'BranchWorkPeriodTypeProxy', id: number, name: string, slug: string }, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null, country: { __typename?: 'Country', id: string, name: string, localeCode: string, continentName: string, isoCode: string, isInEuropeanUnion: boolean }, city?: { __typename?: 'CityProxy', id: number, name: string } | null, phones?: Array<{ __typename?: 'BranchPhoneProxy', id: number, phone: string, branch: { __typename?: 'BranchProxy', id: number, name: string, address: string, timeZone: string, currencyCode: string, deleted: boolean, onlineRegistration: boolean, bookingQrLink: string, removedOfTariff: boolean, isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, country: { __typename?: 'Country', id: string, isInEuropeanUnion: boolean, continentName: string, isoCode: string, localeCode: string, name: string } } }> | null, type?: { __typename?: 'BranchTypeProxy', id: number, name: string, slug?: string | null } | null, category?: { __typename?: 'CompanyTypeProxy', id: number, name: string, type: string } | null, socialLink?: { __typename?: 'BranchSocialLinkProxy', id: number, instagram?: string | null, facebook?: string | null, youtube?: string | null, whatsapp?: string | null, branch: { __typename?: 'BranchProxy', id: number, name: string, address: string, timeZone: string, currencyCode: string, deleted: boolean, onlineRegistration: boolean, bookingQrLink: string, removedOfTariff: boolean, isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, country: { __typename?: 'Country', id: string, isInEuropeanUnion: boolean, continentName: string, isoCode: string, localeCode: string, name: string } } } | null }> | null } | null } | null } | null };

export type GetBranchTypesQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  onlyChild?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyMeMenu?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetBranchTypesQuery = { __typename?: 'Query', branchTypes: Array<{ __typename?: 'BranchTypeProxy', id: number, name: string, slug?: string | null }> };

export type GetCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', countries?: Array<{ __typename?: 'CountryProxy', id: number, name: string, europeanUnion: boolean }> | null } };

export type CreateNewBranchMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.BranchInput;
}>;


export type CreateNewBranchMutation = { __typename?: 'Mutation', createBranch: { __typename?: 'BranchProxy', id: number, name: string, category?: { __typename?: 'CompanyTypeProxy', id: number, name: string } | null, country: { __typename?: 'Country', id: string, name: string } } };

export type UpdateBranchMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.BranchInput;
}>;


export type UpdateBranchMutation = { __typename?: 'Mutation', updateBranch: { __typename?: 'BranchProxy', id: number } };

export type RestoreBranchMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.BranchInput;
}>;


export type RestoreBranchMutation = { __typename?: 'Mutation', restoreBranch: { __typename?: 'BranchProxy', id: number } };

export type DeleteBranchMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteBranchMutation = { __typename?: 'Mutation', deleteBranch: boolean };

export type GetCompanyCreateBranchQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyCreateBranchQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, phone: string, address: string, website?: string | null, country?: { __typename?: 'CountryProxy', id: number, name: string } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null } | null } | null };

export type GetCountryGeoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountryGeoQuery = { __typename?: 'Query', countryGeo?: { __typename?: 'CountryGeoProxy', country?: { __typename?: 'CountryProxy', id: number, isoCode?: string | null, phoneCode?: { __typename?: 'PhoneCodeProxy', code: string } | null, currencies?: Array<{ __typename?: 'CurrencyProxy', id: number }> | null, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null } | null } | null };

export type GetCurrentBranchIdQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentBranchIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, currentBranch?: { __typename?: 'BranchProxy', id: number, name: string } | null } | null };

export type UpdateCurrentBranchMutationVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateCurrentBranchMutation = { __typename?: 'Mutation', updateCurrentBranch: boolean };

export type GetBranchEmployeesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  onlyActive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetBranchEmployeesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string, employeesPaginated?: { __typename?: 'EmployeePaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, employees?: Array<{ __typename?: 'EmployeeProxy', id: number, image?: string | null, name?: string | null, surname?: string | null, specialization?: string | null, role?: { __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean } | null, position?: { __typename?: 'EmployeePositionProxy', name: string } | null, userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', id: number, branch: { __typename?: 'BranchProxy', name: string, id: number }, role: { __typename?: 'RoleProxy', id: number, name: string } }> | null }> | null } | null }> | null } | null } | null };

export type GetBranchesForCompanyQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetBranchesForCompanyQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', name: string, branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', deleted: boolean, id: number, employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', branch: { __typename?: 'BranchProxy', id: number, name: string } }> | null }> | null } | null }> | null } | null } | null } | null };

export type GetIsoCodeForBranchQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetIsoCodeForBranchQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', country?: { __typename?: 'CountryProxy', isoCode?: string | null } | null } | null } | null };

export type GetBranchNameQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetBranchNameQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string }> | null } | null } | null } | null };
